
import { useState } from 'react';

import { Grid, InputAdornment, TextField } from '@mui/material';
import { Search } from '@mui/icons-material/';








export const BuscadorSoloValor = ({ titulo='Buscar...', termino, chageTermino, place='Buscar...'}) => {


    const [valor, setValor] = useState(termino);



    const hanldeInputChange = (e) => {
        e.preventDefault();
        const newValor = e.target.value;
        setValor(newValor);
    }



    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            const newValor = e.target.value;
            chageTermino(newValor)
        }
    };





    return (

        <Grid container sx={{mb:2}} >
            <Grid item xs={12} sm={6}>
                <TextField 
                    autoComplete="off"
                    label={titulo}
                    variant="outlined" 
                    placeholder={place}
                    fullWidth
                    size="small"
                    name="valor"
                    value={valor}
                    onChange={ hanldeInputChange }
                    onKeyDown={handleKeyDown}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <Search />
                            </InputAdornment>
                        ),
                    }}
                />
            </Grid>
        </Grid>

    )
}
    